import { Injectable } from '@angular/core';
import { Cultures } from '../models/enums';

@Injectable({
    providedIn: 'root',
})
export class CultureMappingService {
    // data members

    private _length: number;
    private _keys: Array<string>;
    private _values: Array<number>;

    // constructor

    constructor() {
        this._length = Object.keys(Cultures).length;
        this._keys = Object.keys(Cultures).slice(this._length / 2, this._length);
        this._values = Object.keys(Cultures)
            .slice(0, this._length / 2)
            .map((key) => parseInt(key));
    }

    // public functions

    getResourceNameByCultureName(cultureName: string): string {
        return this.getRightCultureName(cultureName);
    }

    getResourceNameByCultureType(culture: Cultures): string {
        return this.getRightCultureName(this.getCultureNameByCultureType(culture));
    }

    getCultureTypeByCultureName(cultureName: string): Cultures {
        let index = this._keys.findIndex((key) => key.startsWith(cultureName));

        return index >= 0 ? this._values[index] : index;
    }

    getCultureNameByCultureType(culture: Cultures): string {
        let index = this._values.findIndex((value) => value == culture);

        return index >= 0 ? this._keys[index] : '';
    }

    // private functions

    private getRightCultureName(cultureName: string) {
        let key = this._keys.find((key) => key.startsWith(cultureName));
        if (key == null) return cultureName.replace('_', '-');

        return key.toString().replace('_', '-');
    }
}
